/* tslint:disable */
/* eslint-disable */
export enum UpcomingChangesTypeEnum {
  AbonnementAndTilvalg = 'AbonnementAndTilvalg',
  Partner = 'Partner',
  OpkraevningsInterval = 'OpkraevningsInterval'
}
